import { signal } from '@angular/core';
import { TCatalogOption } from '../model';

export const onlineUseStatusCatalog$$ = signal<TCatalogOption[]>([
  { key: 'כן', value: 1 },
  { key: 'לא', value: 0 }
]);
